const WHATNOT_FEE_CHANNEL = "portfolio:whatnot-fee-updates:v1";
const WHATNOT_FEE_STORAGE_KEY = "portfolio:whatnot-fee-updated:v1";
let feeUpdateChannel: BroadcastChannel | null | undefined;

function getFeeUpdateChannel(): BroadcastChannel | null {
  if (typeof window === "undefined" || typeof BroadcastChannel === "undefined") return null;
  if (feeUpdateChannel !== undefined) return feeUpdateChannel;
  try {
    feeUpdateChannel = new BroadcastChannel(WHATNOT_FEE_CHANNEL);
  } catch {
    feeUpdateChannel = null;
  }
  return feeUpdateChannel;
}

/** Generated endpoint keys and handwritten financial keys both use path heads. */
export function isWhatnotFeeAffectedQuery(query: { queryKey: readonly unknown[] }): boolean {
  const head = query.queryKey[0];
  return typeof head === "string" && [
    "/api/sales", "/api/dashboard", "/api/ui/status-summary", "/api/reports",
    "/api/profit-loss", "/api/sales-performance", "/api/product-performance",
    "/api/customers", "/api/customer-insights", "/api/channels",
  ].some((prefix) => head.startsWith(prefix));
}

/** Notify other open app tabs after a committed Whatnot fee change. */
export function publishWhatnotFeeUpdate(): void {
  if (typeof window === "undefined") return;
  const channel = getFeeUpdateChannel();
  if (channel) {
    channel.postMessage({ type: "fees-updated" });
    return;
  }
  try {
    window.localStorage.setItem(WHATNOT_FEE_STORAGE_KEY, `${Date.now()}:${Math.random()}`);
  } catch {
    // Storage can be disabled; same-tab cache invalidation still runs at the caller.
  }
}

/** Subscribe an app query cache to successful fee updates from other tabs. */
export function subscribeToWhatnotFeeUpdates(onUpdate: () => void): () => void {
  if (typeof window === "undefined") return () => {};
  const channel = getFeeUpdateChannel();
  if (channel) {
    const handleMessage = (event: MessageEvent<{ type?: string }>) => {
      if (event.data?.type === "fees-updated") onUpdate();
    };
    channel.addEventListener("message", handleMessage);
    return () => channel.removeEventListener("message", handleMessage);
  }

  const handleStorage = (event: StorageEvent) => {
    if (event.key === WHATNOT_FEE_STORAGE_KEY) onUpdate();
  };
  window.addEventListener("storage", handleStorage);
  return () => window.removeEventListener("storage", handleStorage);
}